import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';
import MuiPagination from '@mui/material/Pagination';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';

import styles from '../styles/pagination.module.scss';

const Pagination = ({
  totalPages,
  currentPage,
  onPageClick,
  siblingCount = 1,
  boundaryCount = 1,
  isHiddenIfSinglePage = false,
}) => {
  if (isHiddenIfSinglePage && totalPages === 1) return null;

  return (
    <MuiPagination
      className={styles.element}
      count={totalPages}
      page={currentPage}
      siblingCount={siblingCount}
      boundaryCount={boundaryCount}
      renderItem={({ type, page }) => {
        if (type === 'start-ellipsis' || type === 'end-ellipsis') {
          return (
            <Typo element="span" key={page} className={styles.ellipsis} role="presentation">
              ...
            </Typo>
          );
        }

        if (type === 'previous' || type === 'next') {
          return (
            <Button
              ariaLabel={i18n.t(`${type}-page`)}
              className={styles.direction}
              key={type}
              testId={`pagination-${type}`}
              variant="ghost"
              size="small"
              icon={type === 'previous' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
              onClick={() => onPageClick(type === 'previous' ? currentPage - 1 : currentPage + 1)}
              isDisabled={type === 'previous' ? currentPage === 1 : currentPage === totalPages}
            />
          );
        }

        return (
          <Button
            ariaLabel={i18n.t('page-number', { number: page })}
            key={page}
            className={classnames(styles.page, {
              [styles.otherPage]: page !== currentPage,
            })}
            size="small"
            color={page === currentPage ? 'primary' : 'secondary'}
            text={page}
            testId={`pagination-page-${page}`}
            onClick={() => onPageClick(page)}
          />
        );
      }}
    />
  );
};

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageClick: PropTypes.func.isRequired,
  siblingCount: PropTypes.number,
  boundaryCount: PropTypes.number,
  isHiddenIfSinglePage: PropTypes.bool,
};

export { Pagination as PaginationStorybook };
export default React.memo(Pagination);
